import type { TableRequestBody, TableRequestColumns } from '@ipfabric/utils';
import type { CloudInternetGatewayDetailData } from './CloudInternetGatewayDetailContent';

interface RequestPayload {
  gatewayId: string;
  snapshotId: string;
}

interface CloudInternetGatewaysRequest {
  url: string;
  method: string;
  data: TableRequestBody<CloudInternetGatewayDetailData>;
}

export const getCloudInternetGatewayDetailRequestPayload = ({
  gatewayId,
  snapshotId,
}: RequestPayload): CloudInternetGatewaysRequest => {
  const columns: TableRequestColumns<CloudInternetGatewayDetailData> = [
    'gatewayId',
    'name',
    'vpcId',
    'type',
    'arn',
  ];
  return {
    url: '/tables/cloud/vendors/aws/internet-gateways',
    method: 'POST',
    data: {
      columns,
      filters: { gatewayId: ['eq', gatewayId] },
      snapshot: snapshotId,
    },
  };
};
